import React, { useState } from "react";
import "./Que1.css";

const Questions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      icon: "💡",
      color: "#3b82f6",
      question: "What technology and digital solutions does PINKMOON Technologies provide?",
      intro:
        "PINKMOON Technologies offers a comprehensive portfolio of next-generation digital and IT solutions, including:",
      points: [
        "Custom Software & Enterprise Product Development",
        "Learning Management Systems (LMS) & EdTech Platforms",
        "Solar & Construction ERP Solutions",
        "Web & Cross-Platform Mobile Application Development",
        "Cloud Infrastructure, DevOps & Data Engineering",
        "Artificial Intelligence & Machine Learning Integration",
      ],
    },
    {
      icon: "🚀",
      color: "#8b5cf6",
      question: "How can PINKMOON help transform and modernize our business?",
      intro:
        "We accelerate digital transformation by automating core business operations, optimizing legacy workflows, modernizing IT infrastructure, and leveraging AI data analytics to boost productivity, cut costs, and unlock new revenue channels.",
    },
    {
      icon: "🏢",
      color: "#10b981",
      question: "Which industries and organizations does PINKMOON serve?",
      intro:
        "We partner with world-class organizations, enterprises, and growth-stage ventures across diverse sectors, including:",
      points: [
        "Healthcare, Telemedicine & EMR Systems",
        "Fintech, Banking & Digital Payments",
        "E-Commerce & Omnichannel Retail",
        "Education, Universities & Corporate Training Centers",
        "Solar, Renewable Energy & Construction ERP",
        "Fleet Management & Logistics Operations",
      ],
    },
    {
      icon: "⚙️",
      color: "#f59e0b",
      question: "Can PINKMOON develop solutions tailored to our specific business requirements?",
      intro:
        "Yes. Every business has unique operational needs. We specialize in end-to-end custom software development tailored to your exact workflows, branding, database architectures, and third-party API requirements.",
    },
    {
      icon: "🛠️",
      color: "#06b6d4",
      question: "What is PINKMOON’s approach to software development and project delivery?",
      intro:
        "We follow an Agile, milestone-driven development process with complete transparency:",
      points: [
        "Discovery & Requirements Engineering",
        "UI/UX Architecture & Prototype Design",
        "Sprint-based Development with CI/CD Pipelines",
        "Rigorous Software Quality & Security Testing",
        "Seamless Deployment & Final Commissioning",
      ],
    },
    {
      icon: "🔒",
      color: "#ef4444",
      question: "How does PINKMOON ensure the security and reliability of its solutions?",
      intro:
        "Security and reliability are built into our engineering lifecycle. We implement enterprise-grade encryption (in transit and at rest), secure OAuth2/JWT authentication, role-based access control (RBAC), regular vulnerability audits, and GDPR compliance.",
    },
    {
      icon: "🎧",
      color: "#ec4899",
      question: "Does PINKMOON provide ongoing maintenance and technical support after deployment?",
      intro:
        "Yes. We offer 24/7 dedicated production support, continuous system health monitoring, SLA-backed maintenance, security patching, and regular feature updates to ensure long-term stability.",
    },
    {
      icon: "🔄",
      color: "#6366f1",
      question: "Can PINKMOON integrate new solutions with our existing systems and applications?",
      intro:
        "Absolutely. Our engineering team designs secure RESTful and GraphQL APIs, custom middleware, and cloud connectors to integrate new software seamlessly with your existing ERPs, CRMs, legacy databases, and payment gateways.",
    },
    {
      icon: "📱",
      color: "#14b8a6",
      question: "Does PINKMOON develop both web and mobile applications?",
      intro:
        "Yes. We build high-performance web portals, progressive web apps (PWAs), and native/cross-platform mobile applications for iOS and Android using modern frameworks like React, React Native, Node.js, and Flutter.",
    },
    {
      icon: "💬",
      color: "#f97316",
      question: "How can we get started with a project or technology consultation?",
      intro:
        "Getting started is effortless! Simply fill out our contact form, send an email to info@pinkmoon.com, or schedule a technology consultation. Our tech leads will respond within 24 hours to conduct a free discovery session.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      <div className="faq-wrapper">
        <div className="faq-header section-header">
          <div className="faq-label section-label">
            <svg
              className="faq-label-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                fill="currentColor"
              />
            </svg>
            <span>FAQ</span>
          </div>
          <h2 className="faq-title section-title">
            Frequently Asked Questions
          </h2>
          <p className="faq-description section-description">
            Find quick answers about our services. Reach out to us directly for
            more information!
          </p>
        </div>

        <div className="faqblock">
          {faqs.map((faq, index) => {
            const isOpen = activeIndex === index;
            return (
              <div
                key={index}
                className={`faq-item-v2 ${isOpen ? "faq-active" : ""}`}
                style={{ "--accent-color": faq.color }}
              >
                <div className="expanded-top-v2" onClick={() => toggleFAQ(index)}>
                  <div className="faq-question-title-wrap">
                    <span
                      className="faq-colorful-badge"
                      style={{
                        background: `${faq.color}15`,
                        color: faq.color,
                        borderColor: `${faq.color}30`,
                      }}
                    >
                      {faq.icon}
                    </span>
                    <h3 className="faq-question-text">{faq.question}</h3>
                  </div>
                  <span
                    className="faq-icon-btn"
                    style={{
                      background: isOpen ? faq.color : "#0f172a",
                    }}
                  >
                    {isOpen ? "−" : "+"}
                  </span>
                </div>

                {isOpen && (
                  <div className="faq-answer-v2">
                    <p className="faq-intro-text">{faq.intro}</p>
                    {faq.points && faq.points.length > 0 && (
                      <ul className="faq-points-list">
                        {faq.points.map((point, pointIndex) => (
                          <li key={pointIndex}>
                            <span
                              className="point-dot"
                              style={{ background: faq.color }}
                            ></span>
                            <span>{point}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Questions;
